import { render, staticRenderFns } from "./robotView.vue?vue&type=template&id=0baa5716&scoped=true"
import script from "./robotView.vue?vue&type=script&lang=js"
export * from "./robotView.vue?vue&type=script&lang=js"
import style0 from "./robotView.vue?vue&type=style&index=0&id=0baa5716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa5716",
  null
  
)

export default component.exports